import axios from 'axios'
import { HEADERS, AUTH_HEADERS } from '../utils/config'
export default {
  login (user) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}auth`, user, HEADERS)
  },
  sessionCheck () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}auth/token/check`, AUTH_HEADERS())
  }
}
